import React, { useEffect } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

const ScoreBoardPieChart = ({ data }) => {
  useEffect(() => {
    const chart = am4core.create("scoreBoardPieChart", am4charts.PieChart);
    chart.data = data;

    const pieSeries = chart.series.push(new am4charts.PieSeries());
    pieSeries.dataFields.value = "value";
    pieSeries.dataFields.category = "category";

    pieSeries.slices.template.tooltipText =
      "{category}: {value} ({value.percent.formatNumber('#.0')}%)";

    pieSeries.labels.template.text = "{category}";
    pieSeries.labels.template.fontSize = 13;

    pieSeries.ticks.template.disabled = false;
    pieSeries.alignLabels = true;

    chart.innerRadius = am4core.percent(40);

    return () => {
      chart.dispose();
    };
  }, [data]);

  return <div id="scoreBoardPieChart" style={{ width: "100%", height: 450 }} />;
};

export default ScoreBoardPieChart;
